import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetActiveSubstanceDrugActivities(drugId: string | undefined) {
  return useQuery(queries.drugCatalog.getActiveSubstanceActivitiesById(drugId || ''))
}
